//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectUserModal from '@/views/common-components/SelectUserModal';
import selectRoleModal from '@/views/common-components/select-role-modal.vue';
import { extend } from '../../../../src/lib/utils/extend';
import ChuTree from 'chu-tree-iview-chg';
import OrganizationEditModal from './OrganizationEditModal';

export default {
    name: 'Index',
    components: {
        OrganizationEditModal: OrganizationEditModal,
        ChuTree: ChuTree,
        SelectUserModal,
        selectRoleModal
    },
    filters: {
        dataRangeType: (input) => {
            switch (input) {
                case 0:
                    return '全部';
                case 1:
                    return '本部门';
                case 2:
                    return '本人';
                case 3:
                    return '本项目';
                case 4:
                    return '本中心';
                case 5:
                    return '本公司';
                case 9:
                    return '指定范围';
                default :
                    return '';
            }
        }
    },
    data() {
        const vm = this;
        return {
            loading: false,
            loadingUser: false,
            loadingRole: false,
            selectedNode: null,
            orgUserColumns: [{
                key: 'id',
                title: 'Id',
                width: 80,
                align: 'center'
            },
                {
                    key: 'userName',
                    title: '用户名'
                },
                {
                    key: 'name',
                    title: '昵称'
                },
                {
                    key: 'actions',
                    title: '操作',
                    width: 100,
                    align: 'center',
                    render(h, params) {
                        return h(
                            'Button', {
                                props: {
                                    size: 'small',
                                    type: 'error'
                                },
                                on: {
                                    click() {
                                        vm.removeUserConfirm(params.row.id);
                                    }
                                }
                            },
                            '移除'
                        );
                    }
                }
            ],
            showAddOrgRoleModal: false,
            orgRoleColumns: [{
                key: 'id',
                title: 'Id',
                width: 80,
                align: 'center'
            },
                {
                    key: 'displayName',
                    title: '角色名称'
                },
                {
                    key: 'actions',
                    title: '操作',
                    width: 100,
                    align: 'center',
                    render(h, params) {
                        return h(
                            'Button', {
                                props: {
                                    size: 'small',
                                    type: 'error'
                                },
                                on: {
                                    click() {
                                        vm.removeRoleConfirm(params.row
                                            .id);
                                    }
                                }
                            },
                            '移除'
                        );
                    }
                }
            ]
        };
    },
    computed: {
        nodes() {
            return this.$store.state.organization.nodes;
        },
        orgUsers() {
            return this.$store.state.organization.users;
        },
        orgRoles() {
            return this.$store.state.organization.roles;
        }
    },
    watch: {
        selectedNode(node, oldValue) {
            if (node.unitType === 'Station') {
                this.getOrgUsers(node.id);
                this.getOrgRoles(node.id);
            }
        }
    },
    created() {
        this.getAllOrganizations();
    },
    methods: {
        getAllOrganizations() {
            this.loading = true;
            this.$store.dispatch({ type: 'organization/getAllOrganizations' })
                .finally(() => {
                    this.loading = false;
                });
        },
        deleteNode(node) {
            abp.message.confirm('确定要删除这个节点？', () => {
                this.loading = true;
                this.$store.commit({ type: 'organization/delete' }, node.id)
                    .finally(() => {
                        this.loading = false;
                    });
            });
        },
        renderTree(h, { root, node, data }) {
            const vm = this;
            return h('span', [
                h('Icon', {
                    props: {
                        type: data.treeIcon,
                        color: data.color
                    },
                    style: {}
                }),
                h(
                    'Button', {
                        props: {
                            type: 'text'
                        },
                        on: {
                            click() {
                                vm.selectedNode = data;
                            }
                        }
                    },
                    data.displayName
                )
            ]);
        },
        showNodeEdit(node, parentUnitType) {
            var editNode = extend(true, {}, node);
            this.$refs.editModal.open(editNode, parentUnitType);
        },
        handleEditSaved(data) {
            this.selectedNode = data;
            this.getAllOrganizations();
        },
        getOrgUsers(orgId) {
            this.loadingUser = true;
            this.$store
                .dispatch({
                    type: 'organization/getOrgUsers',
                    data: {
                        orgId: orgId
                    }
                })
                .finally(() => {
                    this.loadingUser = false;
                });
        },
        showAddOrgUser() {
            this.$refs.selectUserModal.open();
        },
        addOrgUser(user) {
            this.$store
                .dispatch({
                    type: 'organization/addOrgUser',
                    data: {
                        positionId: this.selectedNode.id,
                        userId: user.id
                    }
                })
                .then(() => {
                    this.getOrgUsers(this.selectedNode.id);
                });
        },
        removeUserConfirm(id) {
            this.$Modal.confirm({
                title: '移除用户',
                content: '您确定要移除此用户吗？',
                onOk: () => {
                    this.removeUser(id);
                }
            });
        },
        removeUser(id) {
            this.$store
                .dispatch({
                    type: 'organization/removeOrgUser',
                    data: {
                        id: 0,
                        userId: id,
                        positionId: this.selectedNode.id
                    }
                })
                .then(() => {
                    this.getOrgUsers(this.selectedNode.id);
                });
        },
        getOrgRoles(orgId) {
            this.loadingRole = true;
            this.$store
                .dispatch({
                    type: 'organization/getOrgRoles',
                    data: {
                        orgId: orgId
                    }
                })
                .finally(() => {
                    this.loadingRole = false;
                });
        },
        showAddOrgRole() {
            this.showAddOrgRoleModal = true;
        },
        addOrgRole(role) {
            this.$store
                .dispatch({
                    type: 'organization/addOrgRole',
                    data: {
                        positionId: this.selectedNode.id,
                        roleId: role.id
                    }
                }).then(() => {
                this.showAddOrgRoleModal = false;
                this.getOrgRoles(this.selectedNode.id);
            });
        },
        removeRoleConfirm(id) {
            this.$Modal.confirm({
                title: '移除角色',
                content: '您确定要移除此角色吗？',
                onOk: () => {
                    this.removeRole(id);
                }
            });
        },
        removeRole(id) {
            this.$store
                .dispatch({
                    type: 'organization/removeOrgRole',
                    data: {
                        id: 0,
                        roleId: id,
                        positionId: this.selectedNode.id
                    }
                })
                .then(() => {
                    this.getOrgRoles(this.selectedNode.id);
                });
        },
        expand() {
            this.$store.commit({ type: 'organization/expand' });
        },
        collapse() {
            this.$store.commit({ type: 'organization/collapse' });
        }
    }
};

